$(document).on('click', '.generate-esim-btn', function (e) {

    e.preventDefault();

    var orderId = $(this).data('order-id');

    $('#jl-iccid').text('89812003926010029595');
    $('#jl-lpa').text('LPA:1$rsp.openroam.com$123456');
    $('#jl-qr').attr('src','https://api.qrserver.com/v1/create-qr-code/?size=220x220&data='+orderId);

    $('.jl-esim-details').addClass('active');

    $('html, body').animate({
    scrollTop: $('.jl-esim-details').offset().top - 15
}, 400);

});
